import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getAnalysis } from '../services/analyses';
import AnalysisPreview from '../components/History/AnalysisPreview';

// NUBBI-102 — Vista standalone de un análisis (para abrir "Ver análisis completo" en pestaña nueva)
const AnalysisViewPage = () => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [analysis, setAnalysis] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    getAnalysis(hash, true)
      .then(setAnalysis)
      .catch(() => setError('No se pudo cargar el análisis'));
  }, [hash]);

  const handleClose = () => {
    // Abierto en pestaña nueva: cerrarla; si no se puede (navegación directa), ir al historial
    window.close();
    navigate('/history');
  };

  if (error) {
    return <div style={{ padding: '2rem', color: '#c0392b' }}>{error}</div>;
  }
  if (!analysis) {
    return <div style={{ padding: '2rem', color: '#666' }}>Cargando análisis…</div>;
  }
  return <AnalysisPreview analysis={analysis} onClose={handleClose} />;
};

export default AnalysisViewPage;
